const theme = {
  colors: {
    primary: "#B58762",
    secondary: "#f32f51",
    label: "#1D2129",
  },
}

export default theme
